import "./puzzle-creator.scss";

var userFile = null;
var initialFile = null;
var editorState = null;

const TEST_DPI = false;
const $ = jQuery;

var current_width = 0;
var current_height = 0;
var current_dpi = 0;

var final_rotation = 0;
var final_crop = {};
var final_flipX = false;
var final_flipY = false;

var full_file_name = "";
var uploaded_id = "";

document.addEventListener("DOMContentLoaded", function () {
  const recommended_width = puzzle_width * DESIRED_DPI + BLEED * 2;
  const recommended_height = puzzle_height * DESIRED_DPI + BLEED * 2;
  console.log("Recommended Width:", recommended_width);
  console.log("Recommended Height:", recommended_height);

  $(".bleed").text(BLEED);
  $(".desired-dpi").text(DESIRED_DPI);
  $(".should-upscale").text(SHOULD_UPSCALE);

  console.log("Puzzle Creator loaded");
  console.log("DOM loaded");

  console.log(
    "Loaded With" +
      DESIRED_DPI +
      " DPI " +
      " and " +
      BLEED +
      " Bleed " +
      " and " +
      SHOULD_UPSCALE +
      " Should Upscale "
  );

  new SimpleLightbox(".lightbox", {
    /* options */
  });

  const aspect_ratio = puzzle_width + "/" + puzzle_height;
  console.log("Aspect ratio:", aspect_ratio);

  // Load Pintura adapter
  useEditorWithJQuery(jQuery, pintura);

  var { createDefaultImageWriter, openDefaultEditor } = $.fn.pintura;

  function calculateDPI(
    imageWidthPx,
    imageHeightPx,
    widthInches,
    heightInches
  ) {
    const dpiWidth = imageWidthPx / widthInches;
    const dpiHeight = imageHeightPx / heightInches;
    const averageDPI = (dpiWidth + dpiHeight) / 2;
    return Math.round(averageDPI);
  }

  const handleProcessImage = function (event) {
    console.log("handleProcessImage");
    $("#puzzle-preview").removeClass("quality-warning-visible");

    console.log(event);
    console.log("Image processed:", event.dest);

    const state = event.imageState;

    editorState = state;

    console.log("State:", state);
    const { crop, rotation, flipX, flipY } = state;
    console.log("Crop:", crop);
    console.log("Rotate:", rotation);

    final_rotation = rotation;
    final_crop = crop;
    final_flipX = flipX;
    final_flipY = flipY;

    current_height = crop.height;
    current_width = crop.width;

    $(".current-width").text(current_width);
    $(".current-height").text(current_height);

    const real_dpi = calculateDPI(
      current_width,
      current_height,
      puzzle_width,
      puzzle_height
    );
    $(".current-dpi").text(real_dpi);
    current_dpi = real_dpi;

    // convert real dpi with the downsize factor
    var edited_dpi = real_dpi / $(".downsize-factor").text();
    $(".edited-dpi").text(edited_dpi);

    const file = event.dest;

    const reader = new FileReader();

    reader.onload = function (e) {
      console.log("File loaded:", e);
      const img = new Image();

      img.onload = function () {
        const width = this.width;
        const height = this.height;

        const dpi = calculateDPI(
          width - BLEED * 2,
          height - BLEED * 2,
          puzzle_width,
          puzzle_height
        );

        $(".final-width").text(width);
        $(".final-height").text(height);
        $(".final-dpi").text(dpi);
        $(".final-size").text((file.size / 1024 / 1024).toFixed(2));

        if (TEST_DPI || edited_dpi < MIN_DPI) {
          $("#puzzle-preview").addClass("quality-warning-visible");
        }

        console.log("Width:", width, "Height:", height);
      };

      img.src = e.target.result;
    };

    reader.readAsDataURL(file);

    const imageState = event.detail;
    $("#puzzle-creator-system").removeClass("loading");
    $("#puzzle-creator-system").addClass("image-added");
    console.log("Setting Preview:", URL.createObjectURL(event.dest));
    $(".inline-result").attr("src", URL.createObjectURL(event.dest));
    // console.log("Image processed:", URL.createObjectURL(event.dest));

    userFile = event.dest;
  };

  $(".optimal-width").text(puzzle_width * DESIRED_DPI + BLEED * 2);
  $(".optimal-height").text(puzzle_height * DESIRED_DPI + BLEED * 2);

  const pinturaOptions = {
    imageCropAspectRatio: puzzle_width / puzzle_height,
    enableDropImage: false,
    imageAspectRatio: puzzle_width / puzzle_height,
    imageCropRectAspectRatio: puzzle_width / puzzle_height,
    // utils: ["crop", "rotate"],
    util: "crop",
    utils: ["crop", "rotate", "finetune"],

    enableBrowseImage: false,
    // stickerForceEnable: true,
    canvasMemoryLimit: 8096 * 8096,

    // canvasMemoryLimit: puzzle_width * 50 * (puzzle_height * 50),

    // markupEditorToolbar: [
    //   // ["sharpie", "Sharpie", { disabled: true }],
    //   // ["eraser", "Eraser", { disabled: true }],
    //   // ["rectangle", "Rectangle", { disabled: true }],

    //   ["text", "Text", { disabled: false }]
    // ],

    cropMaskOpacity: 0.9,
    cropEnableFilterMatchAspectRatio: false,

    imageWriter: createDefaultImageWriter({
      targetSize: {
        width: puzzle_width * DESIRED_DPI + BLEED * 2,
        height: puzzle_height * DESIRED_DPI + BLEED * 2,
        fit: "cover",
        mimeType: DESIRED_FILE_TYPE,
        upscale: SHOULD_UPSCALE
      }
    }),

    willRenderCanvas: (shapes, state) => {
      const { utilVisibility, selectionRect, lineColor, backgroundColor } =
        state;

      if (utilVisibility.crop <= 0) return shapes;

      const { x, y, width, height } = selectionRect;

      //   current_width = width;
      //   current_height = height;

      //   $(".current-width").text(current_width);
      //   $(".current-height").text(current_height);

      const desiredWidth = puzzle_width * DESIRED_DPI;
      var bleedwidth = (width / desiredWidth) * BLEED;
      var relativeBleed = bleedwidth;

      if (puzzle_shape === "rectangle") {
        return {
          ...shapes,
          interfaceShapes: [
            {
              x: x + relativeBleed,
              y: y + relativeBleed,
              width: width - relativeBleed * 2,
              height: height - relativeBleed * 2,
              opacity: 1,
              backgroundColor: [4, 187, 255, 0.0],
              strokeWidth: 0.5,
              strokeColor: [0.5, 0.7, 1]
            },
            ...shapes.interfaceShapes
          ]
        };
      }

      if (puzzle_shape === "circle") {
        return {
          ...shapes,
          interfaceShapes: [
            {
              x: x + width * 0.5,
              y: y + height * 0.5,
              rx: width * 0.5,
              ry: height * 0.5,
              opacity: utilVisibility.crop,
              inverted: true,
              backgroundColor: [4, 187, 255, 0.0],

              // backgroundColor: [...backgroundColor, 0.5],
              strokeWidth: 0,
              strokeColor: [0.5, 0.7, 1]

              // strokeColor: [...lineColor]
            },
            {
              x: x + width * 0.5,
              y: y + height * 0.5,
              rx: width * 0.5 - relativeBleed,
              ry: height * 0.5 - relativeBleed,
              opacity: utilVisibility.crop,
              inverted: true,
              // backgroundColor: [...backgroundColor, 0.0],
              backgroundColor: [4, 187, 255, 0.0],
              strokeColor: [0.5, 0.7, 1],

              strokeWidth: 1
              // strokeColor: [...lineColor]
            },
            ...shapes.interfaceShapes
          ]
        };
      }

      if (puzzle_shape === "heart") {
        return {
          ...shapes,
          interfaceShapes: [
            {
              x: x,
              y: y,
              width: width,
              backgroundImage:
                "/wp-content/uploads/2024/06/Heart-bleed-preview-04.png",
              height: height,
              opacity: utilVisibility.crop,
              backgroundColor: [...backgroundColor, 0.0],
              strokeWidth: 0,
              strokeColor: [...lineColor]
            },
            ...shapes.interfaceShapes
          ]
        };
      }

      return shapes;
    }
  };
  function setProgress(targetPercent) {
    const progressText = document.getElementById("progressText");
    const circleProgress = document.querySelector(".circle-progress");
    const startPercent = parseInt(progressText.textContent);
    const clampedTargetPercent = Math.min(Math.max(targetPercent, 0), 100);
    const targetOffset = 440 - (440 * clampedTargetPercent) / 100;

    let currentPercent = startPercent;
    const increment = (clampedTargetPercent - startPercent) / 40; // Update text over 1 second (60 frames)

    function animateText() {
      if (Math.abs(currentPercent - clampedTargetPercent) < 4.9) {
        currentPercent = clampedTargetPercent;
        progressText.textContent = `${clampedTargetPercent}%`;
        return;
      }

      currentPercent += increment;
      progressText.textContent = `${Math.round(currentPercent)}%`;

      requestAnimationFrame(animateText);
    }

    circleProgress.style.strokeDashoffset = targetOffset;
    animateText();
  }

  var fileInput = $("#fileInput");

  fileInput.on("change", async function () {
    $(".error-message").text("");
    if (!fileInput[0].files.length) return;

    const file = fileInput[0].files[0];
    const fileSize = (file.size / 1024 / 1024).toFixed(2);
    // 500kb chunks

    // if file larger than 20mb

    if (fileSize > 21) {
      $(".error-message").text("File size is too large");
      // remove file from input
      fileInput.val("");

      return;
    }

    var chunkSize = 400 * 1024; // 250kb chunks

    if (fileSize > 1 && fileSize <= 5) {
      chunkSize = 500 * 1024; // 500kb chunks
    } else if (fileSize > 5) {
      chunkSize = 1000 * 1024; // 1mb chunks
    }

    const totalChunks = Math.ceil(file.size / chunkSize);
    const fileExtension = file.name.split(".").pop();

    const uploadId =
      Date.now().toString() + Math.random().toString(16).slice(2);

    initialFile = file;

    const circularProgress = document.querySelectorAll(".circular-progress");

    const reader = new FileReader();

    reader.onload = function (e) {
      const img = new Image();

      img.onload = function () {
        const width = this.width;
        const height = this.height;

        const dpi = calculateDPI(width, height, puzzle_width, puzzle_height);

        $(".original-width").text(width);
        $(".original-height").text(height);
        $(".original-dpi").text(dpi);
        $(".original-size").text((file.size / 1024 / 1024).toFixed(2));
      };

      img.src = e.target.result;
    };

    reader.readAsDataURL(file);

    $("#puzzle-creator-system").addClass("uploading");

    // $("#puzzle-creator-system").addClass("loading");
    $("#uploading-text").text("Uploading Image...");

    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      const start = chunkIndex * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);

      // $("#uploading-text").text(
      //   "Uploading Image... " +
      //     Math.round(((chunkIndex + 1) / totalChunks) * 100) +
      //     "%"
      // );

      // calculate based on the chunk index add 1 to the chunk index so the last step is 100%
      var progressValue = Math.round(((chunkIndex + 1) / totalChunks) * 100);
      setProgress(progressValue);

      console.log(
        `Uploading chunk ${chunkIndex + 1} of ${totalChunks}...`,
        chunk
      );

      // if last chunk
      if (chunkIndex === totalChunks - 1) {
        $(".progress-circle").addClass("pulsing");
        console.log("Last chunk");
        $("#uploading-text").text("Processing Image...");
      }

      const formData = new FormData();
      formData.append("file", chunk);
      formData.append("chunk_index", chunkIndex);
      formData.append("total_chunks", totalChunks);
      formData.append("upload_id", uploadId);
      formData.append("action", "upload_original");
      formData.append("file_extension", fileExtension);

      try {
        const response = await $.ajax({
          url: "/wp-admin/admin-ajax.php",
          type: "POST",
          data: formData,
          processData: false,
          contentType: false
        });

        console.log("Got Response:", response.data);

        if (!response.success) {
          $(".error-message").text(
            response.data.message || "Error uploading chunk"
          );
          console.error("Error uploading chunk:", response);
          throw new Error(response.data.message || "Error uploading chunk");
        }

        if (chunkIndex === totalChunks - 1) {
          console.log("Final chunk uploaded:", response.data);
          // Handle the response for the final chunk
          const { thumbnail_url, upload_id, downsize_factor } = response.data;
          $(".progress-circle").removeClass("pulsing");
          $(".upload-id").text(upload_id);
          $(".downsize-factor").text(downsize_factor);

          var editor = openDefaultEditor({
            ...pinturaOptions,
            src: thumbnail_url
          });

          editor.on("process", function (event) {
            handleProcessImage(event);
          });

          $("#uploading-text").text("Image Uploaded");
          // $("#puzzle-creator-system").removeClass("loading");
          $("#puzzle-creator-system").removeClass("uploading");

          console.log(response.data);
        }
      } catch (error) {
        $(".progress-circle").removeClass("pulsing");

        $(".error-message").text(
          error.responseJSON?.data?.message || "Error uploading chunk"
        );
        console.error("Error uploading chunk:", error);
        // $("#puzzle-creator-system").removeClass("loading");
        $("#puzzle-creator-system").removeClass("uploading");
        return;
      }
    }
  });

  $("#download").on("click", function () {
    if (!userFile) {
      console.error("No file selected");
      return;
    }

    const a = document.createElement("a");
    a.href = URL.createObjectURL(userFile);
    a.download = "puzzle.jpg";
    a.click();
  });

  $("#edit").on("click", function () {
    var editor = openDefaultEditor({
      ...pinturaOptions,
      src: initialFile,
      imageState: editorState
    });

    editor.on("process", function (event) {
      console.log("Image processed:", event.dest);
      handleProcessImage(event);
    });
  });

  $("#reset-puzzle").on("click", function () {
    $("#puzzle-creator-system").removeClass("image-added");
    $("#fileInput").val("");
    $(".inline-result").attr("src", "");
    userFile = null;
  });

  $('.product-attributes input[type="radio"]').on("change", function () {
    const attribute = $(this).attr("name");
    const value = $(this).val();
    if (value == "random-cut-pieces") {
      $(".puzzle-img").addClass("random-cut-pieces");
      $(".puzzle-img").removeClass("normal-cut-pieces");
    } else {
      $(".puzzle-img").removeClass("random-cut-pieces");
      $(".puzzle-img").addClass("normal-cut-pieces");
    }

    if (value == "magnetic") {
      // hide
      $(".box-card").hide();
    } else {
      // show
      $(".box-card").show();
    }

    console.log("Attribute:", attribute, "Value:", value);
  });
  $("#save-puzzle").on("click", function () {
    if (!userFile) {
      console.error("No file selected");
      return;
    }

    $("#puzzle-creator-system").addClass("loading");

    const formData = new FormData();
    formData.append("file", userFile);
    formData.append("action", "upload_image");

    var rotation_degrees = final_rotation * (180 / Math.PI);
    // reverse the rotation
    rotation_degrees = 360 - rotation_degrees;

    formData.append("final_rotation", rotation_degrees);
    formData.append("crop_x", final_crop.x);
    formData.append("crop_y", final_crop.y);
    formData.append("crop_width", final_crop.width);
    formData.append("crop_height", final_crop.height);
    formData.append("target_width", (puzzle_width + 0.5) * 25.4);
    formData.append("target_height", (puzzle_height + 0.5) * 25.4);
    formData.append("final_crop", final_crop);
    formData.append("final_flipX", final_flipX);
    formData.append("final_flipY", final_flipY);
    formData.append("upload_id", $(".upload-id").text());
    formData.append("downsize_factor", $(".downsize-factor").text());

    setTimeout(() => {
      $("#loading-text").text("Uploading Image...");
    }, 500);

    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
      success: function (response) {
        if (!response.success) {
          console.error("Error uploading image:", response);
          $("#puzzle-creator-system").removeClass("loading");
          return;
        }

        $("#loading-text").text("Image Uploaded");

        setTimeout(() => {
          $("#loading-text").text("Adding Puzzle to Cart...");
        }, 500);

        const image_url = response.data.url;
        const attachment_id = response.data.id;
        const url = response.data.url;
        const pdf_url = response.data.pdf_url;

        var variations = [];

        $('.product-attributes input[type="radio"]:checked').each(function () {
          const attribute = $(this).attr("name");
          const value = $(this).val();
          variations.push({
            attribute: attribute,
            value: value
          });
        });

        console.log("variations:", JSON.stringify(variations));
        console.log("variations:", variations[0]);
        console.log("variations:", variations);
        console.log("image_url:", image_url);
        console.log("attachment_id:", url);
        console.log("pdf_url:", pdf_url);
        console.log("pdf_url:", pdf_url);
        console.log("pdf_url:", pdf_url);

        console.log(response.data);

        $.ajax({
          url: "/wp-admin/admin-ajax.php",
          type: "POST",
          data: {
            action: "add_to_cart",
            product_id: product_id,
            variations: variations,
            upload_id: $(".upload-id").text(),
            image_url: url,
            pdf_url: pdf_url,
            quantity: 1
          },
          success: function (response) {
            $("#loading-text").text("Puzzle Added to Cart");
            console.log("Product added to cart:", response);

            setTimeout(() => {
              $("#loading-text").text("Redirecting to Cart...");
              window.location.href = "/cart?added=true";
            }, 500);
          },
          error: function (error) {
            console.error("Error adding product to cart:", error);
            $("#error-message").text(
              error.responseJSON?.data?.message ||
                "Error adding product to cart"
            );
            $("#puzzle-creator-system").removeClass("loading");
          }
        });
      },
      error: function (error) {
        console.error("Error uploading image:", error);
        $("#puzzle-creator-system").removeClass("loading");
      }
    });
  });
});
